package models

import kotlinx.serialization.Serializable

@Serializable
data class CategoryModel(
    val id: Int,
    val name: String,
    val parent: String,
    val iscategory: Boolean,
    val isactive: Boolean
)
